// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1rP9O","inner":"Header_inner__rFKIW","logo":"Header_logo__3vt6J","search":"Header_search__YdXNU"};